module.exports = __webpack_public_path__ + "img/solution2.62a7722c.png";